// extracted by mini-css-extract-plugin
module.exports = {"cursor-pointer":"styles-module__cursor-pointer___2oI5t"};